/* eslint-disable */
import {
    getToken,
    getAdminId,
} from "../../../utils/auth";
// import { $NOT_NETWORK } from '../../utils/errorCode'
import { Message } from "element-ui";
import axios from 'axios'
import https from "../../../utils/http";
let http = https.https
const state = {
};

// getters
const getters = {
};

// mutations
const mutations = {
    
};

// actions
const actions = {
    // 用户名登录
    NoticeAdministrationListShow({ commit }, data) {
        data.ADMIN_ID = getAdminId();
        data.ADMIN_TOKEN = getToken();
        return axios.post(http + '/notice/show', data).then(res => {
            return res.data
        })
    },
    AddNoticeAdministration({ commit }, data) {
        data.ADMIN_ID = getAdminId();
        data.ADMIN_TOKEN = getToken();
        return axios.post(http + '/notice/add', data).then(res => {
            return res.data
        })
    },
    DeleteNoticeAdministration({ commit }, data) {
        data.ADMIN_ID = getAdminId();
        data.ADMIN_TOKEN = getToken();
        return axios.post(http + '/notice/delete', data).then(res => {
            return res.data
        })
    },
    Participate({ commit }, data) {
        data.ADMIN_ID = getAdminId();
        data.ADMIN_TOKEN = getToken();
        return axios.post(http + '/notice/show_user', data).then(res => {
            return res.data
        })
    },
    Notice({ commit }, data) {
        data.ADMIN_ID = getAdminId();
        data.ADMIN_TOKEN = getToken();
        return axios.post(http + '/notice/send_msg', data).then(res => {
            return res.data
        })
    }
};

const NoticeAdministrationModule = {
    state,
    getters,
    actions,
    mutations
}
export default NoticeAdministrationModule
